


<div id="st-myspace-layout-body" class="body">
<router-outlet />
</div>